import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Field} from 'redux-form'
import Font from '@cred/react-font'
import Analytics from '@cred/react-analytics'
import {GeosuggestComponent} from './geosuggest'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import withStyles from '@cred/react-theme'

class AddressSearch extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onSelectAddress: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    autoFocusDelay: PropTypes.number,
    styles: PropTypes.object,
    warning: PropTypes.string,
  }

  static defaultProps = {
    autoFocus: false,
    autoFocusDelay: 500,
    autoComplete: 'off',
    styles: defaultStyles,
  }

  constructor(props) {
    super(props)

    this.analytics = new Analytics(props.analytics)
  }

  handleSelect = selection => {
    // Don't throw exception if user wants to clear entered address
    if (!selection) {
      return
    }

    setTimeout(() => {
      const {name, label} = this.props

      this.analytics.event({
        name,
        label,
        error: null
      })
    }, 0)

    const address = selection.gmaps,
      values = {
        fullAddress: selection.description || '',
        street: '',
        city: '',
        county: '',
        state: '',
        zipcode: ''
      },
      {onSelectAddress} = this.props

    let streetNumber

    for (let i = 0; i < address.address_components.length; i++) {
      const component = address.address_components[i]

      if (component.types.indexOf('street_number') > -1) {
        streetNumber = component.long_name
      }

      if (component.types.indexOf('route') > -1) {
        values.street = component.long_name
      }

      // Sometimes, 'sublocality' is the city instead of 'locality'
      if (component.types.indexOf('sublocality') > -1) {
        values.city = component.long_name
      }

      if (component.types.indexOf('locality') > -1) {
        values.city = component.long_name
      }

      if (component.types.indexOf('administrative_area_level_1') > -1) {
        values.state = component.short_name
          ? component.short_name.toUpperCase()
          : undefined
      }

      if (component.types.indexOf('administrative_area_level_2') > -1) {
        values.county = component.long_name
      }

      if (component.types.indexOf('postal_code') > -1) {
        values.zipcode = component.long_name
      }
    }

    if (!values.street || !values.city || !values.state || !values.zipcode) {
      values.complete = false
    } else {
      values.complete = true
    }

    if (!streetNumber) {
      const pieces = values.fullAddress.split(',')

      values.street = pieces[0]
    } else {
      values.street = `${streetNumber} ${values.street}`
    }

    values.name = address.name

    onSelectAddress(values)
  }

  render() {
    const {className, analyticsContexts, styles, warning, ...props} = this.props

    return (
      <Font element="div" className={[styles.address, className].join(' ')}>
        <Field
          component={GeosuggestComponent}
          handleSelect={this.handleSelect}
          analyticsContexts={analyticsContexts}
          warning={warning}
          {...props}
        />
      </Font>
    )
  }
}

export {AddressSearch as AddressSearchNoHoc}

export default /*#__PURE__*/ withStyles(defaultStyles, {credible3})(AddressSearch)
